import { makeStyles } from '@material-ui/core'

export default makeStyles((theme) => ({
  root: {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    width: '100%',
  },
  title: {
    margin: theme.spacing(1, 4),
    fontSize: theme.typography.h4.fontSize,
    fontWeight: theme.typography.fontWeightSemiBold,
    textTransform: 'none',
    textAlign: ({ centered }) => (centered ? 'center' : 'left'),
    width: '100%',
    fontFamily: 'Roboto Condensed',
    color: theme.palette.text.disabled,
    [theme.breakpoints.up('sm')]: {
      fontSize: theme.typography.h4.fontSize,
    },
  },
}))
